// @generated drizzle-zero signature:sha256:c43bfb37f6c714fb357dce9332bd28e42a2edd0693d3ceaa7e45dcd526cd4449
// This file was automatically generated by drizzle-zero.
// You should NOT make any changes in this file as it will be overwritten.

import type { ReadonlyJSONValue } from "@rocicorp/zero";
import type { ZeroCustomType } from "drizzle-zero";
import type { default as zeroSchema } from "../../drizzle-zero.config";
import {
  temporalDateColumn,
  temporalInstantColumn,
  temporalTimeColumn,
} from "./custom-columns";

const accessGrantTable = {
  name: "accessGrant",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    granteeId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "grantee_id",
    },
    granteeType: {
      type: "string",
      optional: false,
      customType: null as unknown as "group" | "user",
      serverName: "grantee_type",
    },
    resourceId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "resource_id",
    },
    resourceType: {
      type: "string",
      optional: false,
      customType: null as unknown as
        | "food"
        | "space"
        | "list"
        | "user"
        | "list_collection"
        | "food_collection"
        | "meal_planning_session",
      serverName: "resource_type",
    },
    resourceScope: {
      type: "string",
      optional: false,
      customType: null as unknown as ZeroCustomType<
        typeof zeroSchema,
        "accessGrant",
        "resourceScope"
      >,
      serverName: "resource_scope",
    },
    role: {
      type: "string",
      optional: false,
      customType: null as unknown as ZeroCustomType<
        typeof zeroSchema,
        "accessGrant",
        "role"
      >,
    },
  },
  primaryKey: ["id"],
  serverName: "access_grant",
} as const;
const agentSessionTable = {
  name: "agentSession",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    agentType: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "agent_type",
    },
    agentVersion: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "agent_version",
    },
    context: {
      type: "json",
      optional: true,
      customType: null as unknown as ReadonlyJSONValue,
    },
  },
  primaryKey: ["id"],
  serverName: "agent_session",
} as const;
const agentSessionMessageTable = {
  name: "agentSessionMessage",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    timeArchived: {
      ...temporalInstantColumn().schema,
      optional: true,
      serverName: "time_archived",
    },
    status: {
      type: "string",
      optional: false,
      customType: null as unknown as
        | "error"
        | "canceled"
        | "streaming"
        | "done",
    },
    sessionId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "session_id",
    },
    role: {
      type: "string",
      optional: false,
      customType: null as unknown as "user" | "assistant" | "system",
    },
    userId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    metadata: {
      type: "json",
      optional: true,
      customType: null as unknown as ReadonlyJSONValue,
    },
    parts: {
      type: "json",
      optional: false,
      customType: null as unknown as ZeroCustomType<
        typeof zeroSchema,
        "agentSessionMessage",
        "parts"
      >,
    },
  },
  primaryKey: ["id"],
  serverName: "agent_session_message",
} as const;
const bodyCharacteristicTable = {
  name: "bodyCharacteristic",
  columns: {
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    timeArchived: {
      ...temporalInstantColumn().schema,
      optional: true,
      serverName: "time_archived",
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    biologicalSex: {
      type: "string",
      optional: true,
      customType: null as unknown as "other" | "male" | "female",
      serverName: "biological_sex",
    },
    dateOfBirth: {
      ...temporalDateColumn().schema,
      optional: true,
      serverName: "date_of_birth",
    },
  },
  primaryKey: ["userId"],
  serverName: "body_characteristic",
} as const;
const bodyMetricTable = {
  name: "bodyMetric",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    key: {
      type: "string",
      optional: true,
      customType: null as unknown as
        | "weight"
        | "leanBodyMass"
        | "height"
        | "bodyFatPercentage",
    },
    unitType: {
      type: "string",
      optional: false,
      customType: null as unknown as
        | "length"
        | "mass"
        | "volume"
        | "energy"
        | "temperature"
        | "time"
        | "pharmacology"
        | "scalar",
      serverName: "unit_type",
    },
  },
  primaryKey: ["id"],
  serverName: "body_metric",
} as const;
const bodyMetricEntryTable = {
  name: "bodyMetricEntry",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    timeArchived: {
      ...temporalInstantColumn().schema,
      optional: true,
      serverName: "time_archived",
    },
    timeStart: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_start",
    },
    timeEnd: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_end",
    },
    timeZone: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "time_zone",
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    timePrecision: {
      type: "string",
      optional: false,
      customType: null as unknown as "date" | "datetime",
      serverName: "time_precision",
    },
    type: {
      type: "string",
      optional: false,
      customType: null as unknown as ZeroCustomType<
        typeof zeroSchema,
        "bodyMetricEntry",
        "type"
      >,
    },
  },
  primaryKey: ["id"],
  serverName: "body_metric_entry",
} as const;
const bodyMetricGoalTable = {
  name: "bodyMetricGoal",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "time_created",
    },
    timeUpdated: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "time_updated",
    },
    timeArchived: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "time_archived",
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    type: {
      type: "string",
      optional: false,
      customType: null as unknown as ZeroCustomType<
        typeof zeroSchema,
        "bodyMetricGoal",
        "type"
      >,
    },
    dateStart: {
      ...temporalDateColumn().schema,
      optional: false,
      serverName: "date_start",
    },
    dateTarget: {
      ...temporalDateColumn().schema,
      optional: true,
      serverName: "date_target",
    },
    dateEnd: {
      ...temporalDateColumn().schema,
      optional: true,
      serverName: "date_end",
    },
    endReason: {
      type: "string",
      optional: true,
      customType: null as unknown as
        | "canceled"
        | "achieved"
        | "missed"
        | "replaced",
      serverName: "end_reason",
    },
  },
  primaryKey: ["id"],
  serverName: "body_metric_goal",
} as const;
const bodyMetricSampleTable = {
  name: "bodyMetricSample",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    timeArchived: {
      ...temporalInstantColumn().schema,
      optional: true,
      serverName: "time_archived",
    },
    timeAt: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_at",
    },
    timeZone: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "time_zone",
    },
    timePrecision: {
      type: "string",
      optional: false,
      customType: null as unknown as "date" | "datetime",
      serverName: "time_precision",
    },
    metricId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "metric_id",
    },
    quantity: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
    },
    unitKey: {
      type: "string",
      optional: false,
      customType: null as unknown as ZeroCustomType<
        typeof zeroSchema,
        "bodyMetricSample",
        "unitKey"
      >,
      serverName: "unit_key",
    },
    entryId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "entry_id",
    },
  },
  primaryKey: ["id"],
  serverName: "body_metric_sample",
} as const;
const bodyMetricTargetTable = {
  name: "bodyMetricTarget",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "time_created",
    },
    timeUpdated: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "time_updated",
    },
    timeArchived: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "time_archived",
    },
    goalId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "goal_id",
    },
    metricId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "metric_id",
    },
    target: {
      type: "json",
      optional: false,
      customType: null as unknown as ZeroCustomType<
        typeof zeroSchema,
        "bodyMetricTarget",
        "target"
      >,
    },
    unitKey: {
      type: "string",
      optional: false,
      customType: null as unknown as ZeroCustomType<
        typeof zeroSchema,
        "bodyMetricTarget",
        "unitKey"
      >,
      serverName: "unit_key",
    },
  },
  primaryKey: ["id"],
  serverName: "body_metric_target",
} as const;
const brandedFoodTable = {
  name: "brandedFood",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    version: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
    },
    code: {
      type: "string",
      optional: true,
      customType: null as unknown as ZeroCustomType<
        typeof zeroSchema,
        "brandedFood",
        "code"
      >,
    },
    brandName: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "brand_name",
    },
    productName: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "product_name",
    },
  },
  primaryKey: ["id", "version"],
  serverName: "branded_food",
} as const;
const brandedFoodServingNutrientTable = {
  name: "brandedFoodServingNutrient",
  columns: {
    foodId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "food_id",
    },
    foodVersion: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "food_version",
    },
    foodServingId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "food_serving_id",
    },
    nutrientId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "nutrient_id",
    },
    amount: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
    },
  },
  primaryKey: ["foodServingId", "nutrientId"],
  serverName: "branded_food_serving_nutrient",
} as const;
const draftTable = {
  name: "draft",
  columns: {
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    timeArchived: {
      ...temporalInstantColumn().schema,
      optional: true,
      serverName: "time_archived",
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    type: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    data: {
      type: "json",
      optional: false,
      customType: null as unknown as ReadonlyJSONValue,
    },
  },
  primaryKey: ["userId", "type"],
} as const;
const externalFoodCollectionTable = {
  name: "externalFoodCollection",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    slug: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
  },
  primaryKey: ["id"],
  serverName: "external_food_collection",
} as const;
const externalFoodIdentityTable = {
  name: "externalFoodIdentity",
  columns: {
    foodId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "food_id",
    },
    collectionId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "collection_id",
    },
    externalId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "external_id",
    },
    externalVariant: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "external_variant",
    },
  },
  primaryKey: ["collectionId", "externalId"],
  serverName: "external_food_identity",
} as const;
const externalFoodProvenanceTable = {
  name: "externalFoodProvenance",
  columns: {
    foodId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "food_id",
    },
    foodVersion: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "food_version",
    },
    collectionId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "collection_id",
    },
    externalId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "external_id",
    },
    externalVersion: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "external_version",
    },
    importVersion: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "import_version",
    },
    externalName: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "external_name",
    },
  },
  primaryKey: [
    "collectionId",
    "externalId",
    "externalVersion",
    "importVersion",
  ],
  serverName: "external_food_provenance",
} as const;
const externalNutrientRefTable = {
  name: "externalNutrientRef",
  columns: {
    nutrientId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "nutrient_id",
    },
    collectionId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "collection_id",
    },
    externalId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "external_id",
    },
  },
  primaryKey: ["collectionId", "externalId"],
  serverName: "external_nutrient_ref",
} as const;
const foodTable = {
  name: "food",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    version: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    modifiers: {
      type: "json",
      optional: false,
      customType: null as unknown as (
        | "raw"
        | "fresh"
        | "cooked"
        | "roasted"
        | "grilled"
        | "fried"
        | "boiled"
        | "steamed"
        | "baked"
        | "frozen"
        | "canned"
        | "dried"
        | "smoked"
        | "cured"
        | "pickled"
      )[],
    },
    iconSlugs: {
      type: "json",
      optional: true,
      customType: null as unknown as string[],
      serverName: "icon_slugs",
    },
  },
  primaryKey: ["id", "version"],
} as const;
const foodCategoryTable = {
  name: "foodCategory",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    timeArchived: {
      ...temporalInstantColumn().schema,
      optional: true,
      serverName: "time_archived",
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    key: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
  },
  primaryKey: ["id"],
  serverName: "food_category",
} as const;
const foodCategoryAssociationTable = {
  name: "foodCategoryAssociation",
  columns: {
    foodId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "food_id",
    },
    foodVersion: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "food_version",
    },
    categoryId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "category_id",
    },
    type: {
      type: "string",
      optional: false,
      customType: null as unknown as "isA" | "contains",
    },
  },
  primaryKey: ["foodId", "foodVersion", "categoryId"],
  serverName: "food_category_association",
} as const;
const foodCategoryClosureTable = {
  name: "foodCategoryClosure",
  columns: {
    ancestorId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "ancestor_id",
    },
    descendantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "descendant_id",
    },
    depth: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
    },
    pathCount: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "path_count",
    },
  },
  primaryKey: ["ancestorId", "descendantId", "depth"],
  serverName: "food_category_closure",
} as const;
const foodCategoryEdgeTable = {
  name: "foodCategoryEdge",
  columns: {
    sourceId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "source_id",
    },
    destinationId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "destination_id",
    },
  },
  primaryKey: ["sourceId", "destinationId"],
  serverName: "food_category_edge",
} as const;
const foodCollectionTable = {
  name: "foodCollection",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    scopeId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "scope_id",
    },
    type: {
      type: "string",
      optional: false,
      customType: null as unknown as "user" | "external",
    },
    allowedFoodTypes: {
      type: "json",
      optional: true,
      customType: null as unknown as (
        | "recipe"
        | "generic"
        | "branded"
        | "recipe_variation"
      )[],
      serverName: "food_types",
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    visibility: {
      type: "string",
      optional: false,
      customType: null as unknown as "public" | "private",
    },
    defaultForUserId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "default_for_user_id",
    },
  },
  primaryKey: ["id"],
  serverName: "food_collection",
} as const;
const foodLogEntryTable = {
  name: "foodLogEntry",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    timeArchived: {
      ...temporalInstantColumn().schema,
      optional: true,
      serverName: "time_archived",
    },
    timeAt: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_at",
    },
    timeZone: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "time_zone",
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    sourceGroupId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "source_group_id",
    },
    foodServingId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "food_serving_id",
    },
    amount: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
    },
  },
  primaryKey: ["id"],
  serverName: "food_log_entry",
} as const;
const foodLogSourceGroupTable = {
  name: "foodLogSourceGroup",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    timeArchived: {
      ...temporalInstantColumn().schema,
      optional: true,
      serverName: "time_archived",
    },
    timeAt: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_at",
    },
    timeZone: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "time_zone",
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    sourceType: {
      type: "string",
      optional: false,
      customType: null as unknown as
        | "planned_meal_occurrence"
        | "planned_meal_event_assignment_v2",
      serverName: "source_type",
    },
    sourceId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "source_id",
    },
  },
  primaryKey: ["id"],
  serverName: "food_log_source_group",
} as const;
const foodMetaTable = {
  name: "foodMeta",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    timeArchived: {
      ...temporalInstantColumn().schema,
      optional: true,
      serverName: "time_archived",
    },
    type: {
      type: "string",
      optional: false,
      customType: null as unknown as
        | "recipe"
        | "generic"
        | "branded"
        | "recipe_variation",
    },
    collectionId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "collection_id",
    },
    currentVersion: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "current_version",
    },
    visibility: {
      type: "string",
      optional: false,
      customType: null as unknown as "public" | "private",
    },
    discoverability: {
      type: "string",
      optional: false,
      customType: null as unknown as "listed" | "unlisted",
    },
  },
  primaryKey: ["id"],
  serverName: "food_meta",
} as const;
const foodServingTable = {
  name: "foodServing",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    sortIndex: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "sort_index",
    },
    foodId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "food_id",
    },
    foodVersion: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "food_version",
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    modifiers: {
      type: "json",
      optional: false,
      customType: null as unknown as (
        | "diced"
        | "chopped"
        | "minced"
        | "sliced"
        | "cubed"
        | "shredded"
        | "mashed"
        | "pureed"
        | "crushed"
        | "crumbled"
        | "crumbs"
        | "drained"
        | "boneless"
        | "packed"
        | "unpopped"
      )[],
    },
    defaultAmount: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "default_amount",
    },
    massQuantity: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "mass_quantity",
    },
    massUnitKey: {
      type: "string",
      optional: true,
      customType: null as unknown as ZeroCustomType<
        typeof zeroSchema,
        "foodServing",
        "massUnitKey"
      >,
      serverName: "mass_unit_key",
    },
    volumeQuantity: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "volume_quantity",
    },
    volumeUnitKey: {
      type: "string",
      optional: true,
      customType: null as unknown as ZeroCustomType<
        typeof zeroSchema,
        "foodServing",
        "volumeUnitKey"
      >,
      serverName: "volume_unit_key",
    },
    nutrients: {
      type: "json",
      optional: false,
      customType: null as unknown as ZeroCustomType<
        typeof zeroSchema,
        "foodServing",
        "nutrients"
      >,
    },
  },
  primaryKey: ["id"],
  serverName: "food_serving",
} as const;
const genericFoodTable = {
  name: "genericFood",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    version: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
    },
  },
  primaryKey: ["id", "version"],
  serverName: "generic_food",
} as const;
const genericFoodNutrientTable = {
  name: "genericFoodNutrient",
  columns: {
    foodId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "food_id",
    },
    foodVersion: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "food_version",
    },
    nutrientId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "nutrient_id",
    },
    amountPer100g: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "amount_per_100g",
    },
  },
  primaryKey: ["foodId", "foodVersion", "nutrientId"],
  serverName: "generic_food_nutrient",
} as const;
const groupTable = {
  name: "group",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
  },
  primaryKey: ["id"],
} as const;
const groupInviteTable = {
  name: "groupInvite",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    groupId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "group_id",
    },
    token: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    createdById: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_id",
    },
    maxUses: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "max_uses",
    },
    useCount: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "use_count",
    },
    timeExpires: {
      ...temporalInstantColumn().schema,
      optional: true,
      serverName: "time_expires",
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
  },
  primaryKey: ["id"],
  serverName: "group_invite",
} as const;
const groupMemberTable = {
  name: "groupMember",
  columns: {
    groupId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "group_id",
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
  },
  primaryKey: ["groupId", "userId"],
  serverName: "group_member",
} as const;
const languageTable = {
  name: "language",
  columns: {
    code: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
  },
  primaryKey: ["code"],
} as const;
const listTable = {
  name: "list",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    timeArchived: {
      ...temporalInstantColumn().schema,
      optional: true,
      serverName: "time_archived",
    },
    type: {
      type: "string",
      optional: false,
      customType: null as unknown as "shopping" | "meal_prep",
    },
    title: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    collectionId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "collection_id",
    },
  },
  primaryKey: ["id"],
} as const;
const listCollectionTable = {
  name: "listCollection",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    defaultForUserId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "default_for_user_id",
    },
  },
  primaryKey: ["id"],
  serverName: "list_collection",
} as const;
const listItemTable = {
  name: "listItem",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    sortIndex: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "sort_index",
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    timeArchived: {
      ...temporalInstantColumn().schema,
      optional: true,
      serverName: "time_archived",
    },
    listId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "list_id",
    },
    sectionId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "section_id",
    },
    label: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
    },
    note: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
    },
    status: {
      type: "string",
      optional: false,
      customType: null as unknown as
        | "pending"
        | "in_progress"
        | "complete"
        | "canceled",
    },
  },
  primaryKey: ["id"],
  serverName: "list_item",
} as const;
const listSectionTable = {
  name: "listSection",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    sortIndex: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "sort_index",
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    timeArchived: {
      ...temporalInstantColumn().schema,
      optional: true,
      serverName: "time_archived",
    },
    listId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "list_id",
    },
    title: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
  },
  primaryKey: ["id"],
  serverName: "list_section",
} as const;
const localeTable = {
  name: "locale",
  columns: {
    language: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    region: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
  },
  primaryKey: ["language", "region"],
} as const;
const mealPlanTable = {
  name: "mealPlan",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    timeArchived: {
      ...temporalInstantColumn().schema,
      optional: true,
      serverName: "time_archived",
    },
    dateStart: {
      ...temporalDateColumn().schema,
      optional: false,
      serverName: "date_start",
    },
    dateEnd: {
      ...temporalDateColumn().schema,
      optional: false,
      serverName: "date_end",
    },
    ownerId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "owner_id",
    },
    status: {
      type: "string",
      optional: false,
      customType: null as unknown as "draft" | "published",
    },
  },
  primaryKey: ["id"],
  serverName: "meal_plan",
} as const;
const mealPlanAgentSessionTable = {
  name: "mealPlanAgentSession",
  columns: {
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    timeArchived: {
      ...temporalInstantColumn().schema,
      optional: true,
      serverName: "time_archived",
    },
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    mealPlanId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_plan_id",
    },
  },
  primaryKey: ["id"],
  serverName: "meal_plan_agent_session",
} as const;
const mealPlanInviteTable = {
  name: "mealPlanInvite",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    mealPlanId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_plan_id",
    },
    createdByUserId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "created_by_user_id",
    },
    token: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    maxUses: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "max_uses",
    },
    usedCount: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "used_count",
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeExpires: {
      ...temporalInstantColumn().schema,
      optional: true,
      serverName: "time_expires",
    },
  },
  primaryKey: ["id"],
  serverName: "meal_plan_invite",
} as const;
const mealPlanMealWorkflowExecutionTable = {
  name: "mealPlanMealWorkflowExecution",
  columns: {
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    mealPlanId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_plan_id",
    },
    mealId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_id",
    },
    workflowExecutionId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "workflow_execution_id",
    },
    agentSessionId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "agent_session_id",
    },
  },
  primaryKey: ["id"],
  serverName: "meal_plan_meal_workflow_execution",
} as const;
const mealPlanMemberTable = {
  name: "mealPlanMember",
  columns: {
    mealPlanId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_plan_id",
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
  },
  primaryKey: ["mealPlanId", "userId"],
  serverName: "meal_plan_member",
} as const;
const mealPlanningMemberContextAgentSessionTable = {
  name: "mealPlanningMemberContextAgentSession",
  columns: {
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    mealPlanningSessionId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_planning_session_id",
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
  },
  primaryKey: ["id"],
  serverName: "meal_planning_member_context_agent_session",
} as const;
const mealPlanningSessionTable = {
  name: "mealPlanningSession",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    scopeId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "scope_id",
    },
    dateStart: {
      ...temporalDateColumn().schema,
      optional: false,
      serverName: "date_start",
    },
    dateEnd: {
      ...temporalDateColumn().schema,
      optional: false,
      serverName: "date_end",
    },
    timeZone: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "time_zone",
    },
  },
  primaryKey: ["id"],
  serverName: "meal_planning_session",
} as const;
const mealPlanningSessionMemberContextTable = {
  name: "mealPlanningSessionMemberContext",
  columns: {
    mealPlanningSessionId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_planning_session_id",
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    data: {
      type: "json",
      optional: false,
      customType: null as unknown as ZeroCustomType<
        typeof zeroSchema,
        "mealPlanningSessionMemberContext",
        "data"
      >,
    },
  },
  primaryKey: ["mealPlanningSessionId", "userId"],
  serverName: "meal_planning_session_member_context",
} as const;
const mealPlanningSessionPlannedMealTable = {
  name: "mealPlanningSessionPlannedMeal",
  columns: {
    mealPlanningSessionId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_planning_session_id",
    },
    scopeId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "scope_id",
    },
    plannedMealId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "planned_meal_id",
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
  },
  primaryKey: ["mealPlanningSessionId", "plannedMealId"],
  serverName: "meal_planning_session_planned_meal",
} as const;
const mealPlanningSessionPlannerAgentSessionTable = {
  name: "mealPlanningSessionPlannerAgentSession",
  columns: {
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    mealPlanningSessionId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_planning_session_id",
    },
  },
  primaryKey: ["id"],
  serverName: "meal_planning_session_planner_agent_session",
} as const;
const mealPlanningSessionScheduleConfigTable = {
  name: "mealPlanningSessionScheduleConfig",
  columns: {
    mealPlanningSessionId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_planning_session_id",
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    data: {
      type: "json",
      optional: false,
      customType: null as unknown as ZeroCustomType<
        typeof zeroSchema,
        "mealPlanningSessionScheduleConfig",
        "data"
      >,
    },
  },
  primaryKey: ["mealPlanningSessionId"],
  serverName: "meal_planning_session_schedule_config",
} as const;
const mealPlanningWorkflowExecutionTable = {
  name: "mealPlanningWorkflowExecution",
  columns: {
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    mealPlanningSessionId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_planning_session_id",
    },
    plannedMealId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "planned_meal_id",
    },
    agentSessionId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "agent_session_id",
    },
  },
  primaryKey: ["id"],
  serverName: "meal_planning_workflow_execution",
} as const;
const mealScheduleTable = {
  name: "mealSchedule",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    scopeId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "scope_id",
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
  },
  primaryKey: ["id"],
  serverName: "meal_schedule",
} as const;
const mealScheduleSlotTable = {
  name: "mealScheduleSlot",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    sortIndex: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "sort_index",
    },
    mealScheduleId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_schedule_id",
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    time: {
      ...temporalTimeColumn().schema,
      optional: false,
    },
  },
  primaryKey: ["id"],
  serverName: "meal_schedule_slot",
} as const;
const nutrientTable = {
  name: "nutrient",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    defaultName: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "default_name",
    },
    key: {
      type: "string",
      optional: true,
      customType: null as unknown as
        | "energy"
        | "alcohol"
        | "vitaminB7"
        | "caffeine"
        | "calcium"
        | "carbohydrate"
        | "cholesterol"
        | "copper"
        | "cystine"
        | "fat"
        | "fatMonounsaturated"
        | "omega3ALA"
        | "omega3DPA"
        | "omega3EPA"
        | "omega6"
        | "fatPolyunsaturated"
        | "fatSaturated"
        | "fatTrans"
        | "fiber"
        | "vitaminB9"
        | "histidine"
        | "iron"
        | "isoleucine"
        | "leucine"
        | "lysine"
        | "magnesium"
        | "manganese"
        | "methionine"
        | "phenylalanine"
        | "phosphorus"
        | "potassium"
        | "protein"
        | "selenium"
        | "sodium"
        | "starch"
        | "sugar"
        | "sugarAdded"
        | "threonine"
        | "tryptophan"
        | "tyrosine"
        | "valine"
        | "vitaminA"
        | "vitaminB1"
        | "vitaminB12"
        | "vitaminB2"
        | "vitaminB3"
        | "vitaminB5"
        | "vitaminB6"
        | "vitaminC"
        | "vitaminD"
        | "vitaminE"
        | "vitaminK"
        | "water"
        | "zinc",
    },
    unitKey: {
      type: "string",
      optional: false,
      customType: null as unknown as ZeroCustomType<
        typeof zeroSchema,
        "nutrient",
        "unitKey"
      >,
      serverName: "unit_key",
    },
    type: {
      type: "string",
      optional: false,
      customType: null as unknown as
        | "carbohydrate"
        | "fat"
        | "protein"
        | "vitamin"
        | "mineral"
        | "other",
    },
  },
  primaryKey: ["id"],
} as const;
const nutritionProgramTable = {
  name: "nutritionProgram",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "time_created",
    },
    timeUpdated: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "time_updated",
    },
    timeArchived: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "time_archived",
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    dateStart: {
      ...temporalDateColumn().schema,
      optional: false,
      serverName: "date_start",
    },
    dateEnd: {
      ...temporalDateColumn().schema,
      optional: true,
      serverName: "date_end",
    },
  },
  primaryKey: ["id"],
  serverName: "nutrition_program",
} as const;
const nutritionProgramDayTable = {
  name: "nutritionProgramDay",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    programId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "program_id",
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    dateSelector: {
      type: "json",
      optional: true,
      customType: null as unknown as
        | { type: "default" }
        | {
            type: "dayOfWeek";
            values: (
              | "Monday"
              | "Tuesday"
              | "Wednesday"
              | "Thursday"
              | "Friday"
              | "Saturday"
              | "Sunday"
            )[];
          },
      serverName: "date_selector",
    },
    macroDistribution: {
      type: "json",
      optional: true,
      customType: null as unknown as ZeroCustomType<
        typeof zeroSchema,
        "nutritionProgramDay",
        "macroDistribution"
      >,
      serverName: "macro_distribution",
    },
    expenditureOverrideActivityFactor: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "expenditure_override_activity_factor",
    },
    expenditureAdditionalOffset: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "expenditure_additional_offset",
    },
    nutrientTargets: {
      type: "json",
      optional: false,
      customType: null as unknown as ZeroCustomType<
        typeof zeroSchema,
        "nutritionProgramDay",
        "nutrientTargets"
      >,
      serverName: "nutrient_targets",
    },
  },
  primaryKey: ["id"],
  serverName: "nutrition_program_day",
} as const;
const nutritionProgramExpenditureTable = {
  name: "nutritionProgramExpenditure",
  columns: {
    programId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "program_id",
    },
    rmrParameters: {
      type: "json",
      optional: false,
      customType: null as unknown as ZeroCustomType<
        typeof zeroSchema,
        "nutritionProgramExpenditure",
        "rmrParameters"
      >,
      serverName: "rmr_parameters",
    },
    activityFactor: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "activity_factor",
    },
    calibrationOffset: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "calibration_offset",
    },
    goalId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "goal_id",
    },
    goalOffset: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "offset",
    },
  },
  primaryKey: ["programId"],
  serverName: "nutrition_program_expenditure",
} as const;
const plannedMealTable = {
  name: "plannedMeal",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    timeArchived: {
      ...temporalInstantColumn().schema,
      optional: true,
      serverName: "time_archived",
    },
    sortIndex: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "sort_index",
    },
    mealPlanId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_plan_id",
    },
    mealSlotId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_slot_id",
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    groupId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "group_id",
    },
  },
  primaryKey: ["id"],
  serverName: "planned_meal",
} as const;
const plannedMealEventAssignmentV2Table = {
  name: "plannedMealEventAssignmentV2",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    mealId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_id",
    },
    eventId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "event_id",
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    plateId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "plate_id",
    },
  },
  primaryKey: ["id"],
  serverName: "planned_meal_event_assignment_v2",
} as const;
const plannedMealEventV2Table = {
  name: "plannedMealEventV2",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    mealId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_id",
    },
    timeAt: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_at",
    },
    timeZone: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "time_zone",
    },
  },
  primaryKey: ["id"],
  serverName: "planned_meal_event_v2",
} as const;
const plannedMealItemTable = {
  name: "plannedMealItem",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    timeArchived: {
      ...temporalInstantColumn().schema,
      optional: true,
      serverName: "time_archived",
    },
    sortIndex: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "sort_index",
    },
    mealPlanId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_plan_id",
    },
    mealId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_id",
    },
    foodServingId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "food_serving_id",
    },
    amount: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
    },
  },
  primaryKey: ["id"],
  serverName: "planned_meal_item",
} as const;
const plannedMealItemDescriptorTable = {
  name: "plannedMealItemDescriptor",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    timeArchived: {
      ...temporalInstantColumn().schema,
      optional: true,
      serverName: "time_archived",
    },
    sortIndex: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "sort_index",
    },
    mealPlanId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_plan_id",
    },
    mealId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_id",
    },
    data: {
      type: "json",
      optional: false,
      customType: null as unknown as {
        name: string;
        modifiers: string[];
        brand: string | null;
        quantity: number;
        unit: string | null;
      },
    },
  },
  primaryKey: ["id"],
  serverName: "planned_meal_item_descriptor",
} as const;
const plannedMealNutrientTargetsTable = {
  name: "plannedMealNutrientTargets",
  columns: {
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    timeArchived: {
      ...temporalInstantColumn().schema,
      optional: true,
      serverName: "time_archived",
    },
    mealPlanId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_plan_id",
    },
    mealSlotId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_slot_id",
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    nutrientTargets: {
      type: "json",
      optional: false,
      customType: null as unknown as ZeroCustomType<
        typeof zeroSchema,
        "plannedMealNutrientTargets",
        "nutrientTargets"
      >,
      serverName: "nutrient_targets",
    },
  },
  primaryKey: ["mealPlanId", "mealSlotId", "userId"],
  serverName: "planned_meal_nutrient_targets",
} as const;
const plannedMealOccurrenceTable = {
  name: "plannedMealOccurrence",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    timeArchived: {
      ...temporalInstantColumn().schema,
      optional: true,
      serverName: "time_archived",
    },
    date: {
      ...temporalDateColumn().schema,
      optional: true,
    },
    mealPlanId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_plan_id",
    },
    mealId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_id",
    },
    mealSlotId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_slot_id",
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
  },
  primaryKey: ["id"],
  serverName: "planned_meal_occurrence",
} as const;
const plannedMealPlateItemDescriptorV2Table = {
  name: "plannedMealPlateItemDescriptorV2",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    sortIndex: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "sort_index",
    },
    mealId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_id",
    },
    plateId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "plate_id",
    },
    data: {
      type: "json",
      optional: false,
      customType: null as unknown as {
        name: string;
        modifiers: string[];
        brand: string | null;
        quantity: number;
        unit: string | null;
      },
    },
  },
  primaryKey: ["id"],
  serverName: "planned_meal_plate_item_descriptor_v2",
} as const;
const plannedMealPlateItemV2Table = {
  name: "plannedMealPlateItemV2",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    sortIndex: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "sort_index",
    },
    mealId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_id",
    },
    plateId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "plate_id",
    },
    foodServingId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "food_serving_id",
    },
    amount: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
    },
  },
  primaryKey: ["id"],
  serverName: "planned_meal_plate_item_v2",
} as const;
const plannedMealPlateV2Table = {
  name: "plannedMealPlateV2",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    mealId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_id",
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    nutrientTargets: {
      type: "json",
      optional: true,
      customType: null as unknown as ZeroCustomType<
        typeof zeroSchema,
        "plannedMealPlateV2",
        "nutrientTargets"
      >,
      serverName: "nutrient_targets",
    },
  },
  primaryKey: ["id"],
  serverName: "planned_meal_plate_v2",
} as const;
const plannedMealSlotTable = {
  name: "plannedMealSlot",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    timeArchived: {
      ...temporalInstantColumn().schema,
      optional: true,
      serverName: "time_archived",
    },
    mealPlanId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "meal_plan_id",
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    time: {
      ...temporalTimeColumn().schema,
      optional: false,
    },
  },
  primaryKey: ["id"],
  serverName: "planned_meal_slot",
} as const;
const plannedMealV2Table = {
  name: "plannedMealV2",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    scopeId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "scope_id",
    },
    typeLabel: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "type_label",
    },
    status: {
      type: "string",
      optional: false,
      customType: null as unknown as "draft" | "published",
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
  },
  primaryKey: ["id"],
  serverName: "planned_meal_v2",
} as const;
const recipeTable = {
  name: "recipe",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    version: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
    },
    description: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
    },
    prepTimeMinutes: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "prep_time_minutes",
    },
    cookTimeMinutes: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "cook_time_minutes",
    },
  },
  primaryKey: ["id", "version"],
} as const;
const recipeIngredientTable = {
  name: "recipeIngredient",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    sortIndex: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "sort_index",
    },
    recipeId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "recipe_id",
    },
    recipeVersion: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "recipe_version",
    },
    foodServingId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "food_serving_id",
    },
    amount: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
    },
  },
  primaryKey: ["id"],
  serverName: "recipe_ingredient",
} as const;
const recipeNutrientTable = {
  name: "recipeNutrient",
  columns: {
    recipeId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "recipe_id",
    },
    recipeVersion: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "recipe_version",
    },
    nutrientId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "nutrient_id",
    },
    amount: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
    },
  },
  primaryKey: ["recipeId", "recipeVersion", "nutrientId"],
  serverName: "recipe_nutrient",
} as const;
const recipeServingTable = {
  name: "recipeServing",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    recipeId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "recipe_id",
    },
    recipeVersion: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "recipe_version",
    },
    perRecipe: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "per_recipe",
    },
  },
  primaryKey: ["id"],
  serverName: "recipe_serving",
} as const;
const recipeStepTable = {
  name: "recipeStep",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    sortIndex: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "sort_index",
    },
    recipeId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "recipe_id",
    },
    recipeVersion: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "recipe_version",
    },
    text: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
  },
  primaryKey: ["id"],
  serverName: "recipe_step",
} as const;
const recipeVariationTable = {
  name: "recipeVariation",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    version: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
    },
    recipeId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "recipe_id",
    },
    recipeVersion: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "recipe_version",
    },
    kind: {
      type: "string",
      optional: false,
      customType: null as unknown as "custom" | "curated",
    },
    detailsPatch: {
      type: "json",
      optional: true,
      customType: null as unknown as {
        description?: string | null | undefined;
        prepTimeMinutes?: number | null | undefined;
        cookTimeMinutes?: number | null | undefined;
      },
      serverName: "details_patch",
    },
  },
  primaryKey: ["id", "version"],
  serverName: "recipe_variation",
} as const;
const recipeVariationIngredientPatchTable = {
  name: "recipeVariationIngredientPatch",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    recipeVariationId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "recipe_variation_id",
    },
    recipeVariationVersion: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "recipe_variation_version",
    },
    op: {
      type: "string",
      optional: false,
      customType: null as unknown as "create" | "update" | "delete",
    },
    baseFoodServingId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "base_food_serving_id",
    },
    newFoodServingId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "new_food_serving_id",
    },
    data: {
      type: "json",
      optional: true,
      customType: null as unknown as {
        amount?: number | undefined;
        sortIndex?: string | undefined;
      },
    },
  },
  primaryKey: ["id"],
  serverName: "recipe_variation_ingredient_patch",
} as const;
const recipeVariationNutrientTable = {
  name: "recipeVariationNutrient",
  columns: {
    recipeVariationId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "recipe_variation_id",
    },
    recipeVariationVersion: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "recipe_variation_version",
    },
    nutrientId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "nutrient_id",
    },
    amount: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
    },
  },
  primaryKey: ["recipeVariationId", "recipeVariationVersion", "nutrientId"],
  serverName: "recipe_variation_nutrient",
} as const;
const recipeVariationStepPatchTable = {
  name: "recipeVariationStepPatch",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    recipeVariationId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "recipe_variation_id",
    },
    recipeVariationVersion: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "recipe_variation_version",
    },
    op: {
      type: "string",
      optional: false,
      customType: null as unknown as "create" | "update" | "delete",
    },
    baseSortIndex: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "base_sort_index",
    },
    newSortIndex: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "new_sort_index",
    },
    data: {
      type: "json",
      optional: true,
      customType: null as unknown as { text?: string | undefined },
    },
  },
  primaryKey: ["id"],
  serverName: "recipe_variation_step_patch",
} as const;
const scopeTable = {
  name: "scope",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    userId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    spaceId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "space_id",
    },
    mealPlanningSessionId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "meal_planning_session_id",
    },
  },
  primaryKey: ["id"],
} as const;
const shoppingListTable = {
  name: "shoppingList",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    mealPlanId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "meal_plan_id",
    },
  },
  primaryKey: ["id"],
  serverName: "shopping_list",
} as const;
const shoppingListFoodItemTable = {
  name: "shoppingListFoodItem",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    shoppingListId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "shopping_list_id",
    },
    foodServingId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "food_serving_id",
    },
    amount: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
    },
  },
  primaryKey: ["id"],
  serverName: "shopping_list_food_item",
} as const;
const spaceTable = {
  name: "space",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    timeUpdated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_updated",
    },
    timeArchived: {
      ...temporalInstantColumn().schema,
      optional: true,
      serverName: "time_archived",
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
  },
  primaryKey: ["id"],
} as const;
const unitTable = {
  name: "unit",
  columns: {
    key: {
      type: "string",
      optional: false,
      customType: null as unknown as ZeroCustomType<
        typeof zeroSchema,
        "unit",
        "key"
      >,
    },
    type: {
      type: "string",
      optional: false,
      customType: null as unknown as
        | "length"
        | "mass"
        | "volume"
        | "energy"
        | "temperature"
        | "time"
        | "pharmacology"
        | "scalar",
    },
    defaultName: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "default_name",
    },
    defaultAliases: {
      type: "json",
      optional: false,
      customType: null as unknown as string[],
      serverName: "default_aliases",
    },
  },
  primaryKey: ["key"],
} as const;
const unitLocalizationTable = {
  name: "unitLocalization",
  columns: {
    unitKey: {
      type: "string",
      optional: false,
      customType: null as unknown as ZeroCustomType<
        typeof zeroSchema,
        "unitLocalization",
        "unitKey"
      >,
      serverName: "unit_key",
    },
    language: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    region: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    aliases: {
      type: "json",
      optional: false,
      customType: null as unknown as string[],
    },
  },
  primaryKey: ["unitKey", "language", "region"],
  serverName: "unit_localization",
} as const;
const userProfileTable = {
  name: "userProfile",
  columns: {
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    image: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
    },
  },
  primaryKey: ["userId"],
  serverName: "user_profile",
} as const;
const workflowExecutionTable = {
  name: "workflowExecution",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    workflowType: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "workflow_type",
    },
    workflowVersion: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "workflow_version",
    },
    status: {
      type: "string",
      optional: false,
      customType: null as unknown as ZeroCustomType<
        typeof zeroSchema,
        "workflowExecution",
        "status"
      >,
    },
    context: {
      type: "json",
      optional: false,
      customType: null as unknown as ReadonlyJSONValue,
    },
    error: {
      type: "json",
      optional: true,
      customType: null as unknown as ZeroCustomType<
        typeof zeroSchema,
        "workflowExecution",
        "error"
      >,
    },
    metadata: {
      type: "json",
      optional: true,
      customType: null as unknown as ReadonlyJSONValue,
    },
  },
  primaryKey: ["id"],
  serverName: "workflow_execution",
} as const;
const workflowExecutionStepTable = {
  name: "workflowExecutionStep",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    sortIndex: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "sort_index",
    },
    timeCreated: {
      ...temporalInstantColumn().schema,
      optional: false,
      serverName: "time_created",
    },
    executionId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "execution_id",
    },
    stepName: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "step_name",
    },
    status: {
      type: "string",
      optional: false,
      customType: null as unknown as ZeroCustomType<
        typeof zeroSchema,
        "workflowExecutionStep",
        "status"
      >,
    },
    input: {
      type: "json",
      optional: false,
      customType: null as unknown as ReadonlyJSONValue,
    },
    output: {
      type: "json",
      optional: true,
      customType: null as unknown as ReadonlyJSONValue,
    },
    error: {
      type: "json",
      optional: true,
      customType: null as unknown as ZeroCustomType<
        typeof zeroSchema,
        "workflowExecutionStep",
        "error"
      >,
    },
    metadata: {
      type: "json",
      optional: true,
      customType: null as unknown as ReadonlyJSONValue,
    },
    retryCount: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "retry_count",
    },
    maxRetries: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "max_retries",
    },
    parentStepId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "parent_step_id",
    },
    timeStarted: {
      ...temporalInstantColumn().schema,
      optional: true,
      serverName: "time_started",
    },
    timeEnded: {
      ...temporalInstantColumn().schema,
      optional: true,
      serverName: "time_ended",
    },
  },
  primaryKey: ["id"],
  serverName: "workflow_execution_step",
} as const;
const agentSessionMessageRelationships = {
  session: [
    {
      sourceField: ["sessionId"],
      destField: ["id"],
      destSchema: "agentSession",
      cardinality: "one",
    },
  ],
} as const;
const agentSessionRelationships = {
  messages: [
    {
      sourceField: ["id"],
      destField: ["sessionId"],
      destSchema: "agentSessionMessage",
      cardinality: "many",
    },
  ],
  mealPlanAgentSession: [
    {
      sourceField: ["id"],
      destField: ["id"],
      destSchema: "mealPlanAgentSession",
      cardinality: "one",
    },
  ],
  mealPlanningMemberContextAgentSession: [
    {
      sourceField: ["id"],
      destField: ["id"],
      destSchema: "mealPlanningMemberContextAgentSession",
      cardinality: "one",
    },
  ],
  mealPlanningSessionPlannerAgentSession: [
    {
      sourceField: ["id"],
      destField: ["id"],
      destSchema: "mealPlanningSessionPlannerAgentSession",
      cardinality: "one",
    },
  ],
} as const;
const bodyMetricEntryRelationships = {
  samples: [
    {
      sourceField: ["id"],
      destField: ["entryId"],
      destSchema: "bodyMetricSample",
      cardinality: "many",
    },
  ],
} as const;
const bodyMetricGoalRelationships = {
  targets: [
    {
      sourceField: ["id"],
      destField: ["goalId"],
      destSchema: "bodyMetricTarget",
      cardinality: "many",
    },
  ],
} as const;
const bodyMetricSampleRelationships = {
  unit: [
    {
      sourceField: ["unitKey"],
      destField: ["key"],
      destSchema: "unit",
      cardinality: "one",
    },
  ],
  entry: [
    {
      sourceField: ["entryId"],
      destField: ["id"],
      destSchema: "bodyMetricEntry",
      cardinality: "one",
    },
  ],
  metric: [
    {
      sourceField: ["metricId"],
      destField: ["id"],
      destSchema: "bodyMetric",
      cardinality: "one",
    },
  ],
} as const;
const bodyMetricTargetRelationships = {
  goal: [
    {
      sourceField: ["goalId"],
      destField: ["id"],
      destSchema: "bodyMetricGoal",
      cardinality: "one",
    },
  ],
  metric: [
    {
      sourceField: ["metricId"],
      destField: ["id"],
      destSchema: "bodyMetric",
      cardinality: "one",
    },
  ],
  unit: [
    {
      sourceField: ["unitKey"],
      destField: ["key"],
      destSchema: "unit",
      cardinality: "one",
    },
  ],
} as const;
const brandedFoodRelationships = {
  base: [
    {
      sourceField: ["id", "version"],
      destField: ["id", "version"],
      destSchema: "food",
      cardinality: "one",
    },
  ],
  meta: [
    {
      sourceField: ["id"],
      destField: ["id"],
      destSchema: "foodMeta",
      cardinality: "one",
    },
  ],
  metaIfCurrent: [
    {
      sourceField: ["id", "version"],
      destField: ["id", "currentVersion"],
      destSchema: "foodMeta",
      cardinality: "one",
    },
  ],
} as const;
const externalFoodIdentityRelationships = {
  foodMeta: [
    {
      sourceField: ["foodId"],
      destField: ["id"],
      destSchema: "foodMeta",
      cardinality: "one",
    },
  ],
  collection: [
    {
      sourceField: ["collectionId"],
      destField: ["id"],
      destSchema: "externalFoodCollection",
      cardinality: "one",
    },
  ],
} as const;
const externalFoodProvenanceRelationships = {
  food: [
    {
      sourceField: ["foodId", "foodVersion"],
      destField: ["id", "version"],
      destSchema: "food",
      cardinality: "one",
    },
  ],
  collection: [
    {
      sourceField: ["collectionId"],
      destField: ["id"],
      destSchema: "externalFoodCollection",
      cardinality: "one",
    },
  ],
} as const;
const foodCategoryAssociationRelationships = {
  food: [
    {
      sourceField: ["foodId", "foodVersion"],
      destField: ["id", "version"],
      destSchema: "food",
      cardinality: "one",
    },
  ],
  category: [
    {
      sourceField: ["categoryId"],
      destField: ["id"],
      destSchema: "foodCategory",
      cardinality: "one",
    },
  ],
} as const;
const foodCategoryClosureRelationships = {
  ancestor: [
    {
      sourceField: ["ancestorId"],
      destField: ["id"],
      destSchema: "foodCategory",
      cardinality: "one",
    },
  ],
  descendant: [
    {
      sourceField: ["descendantId"],
      destField: ["id"],
      destSchema: "foodCategory",
      cardinality: "one",
    },
  ],
} as const;
const foodCategoryEdgeRelationships = {
  source: [
    {
      sourceField: ["sourceId"],
      destField: ["id"],
      destSchema: "foodCategory",
      cardinality: "one",
    },
  ],
  destination: [
    {
      sourceField: ["destinationId"],
      destField: ["id"],
      destSchema: "foodCategory",
      cardinality: "one",
    },
  ],
} as const;
const foodCategoryRelationships = {
  sourceEdges: [
    {
      sourceField: ["id"],
      destField: ["sourceId"],
      destSchema: "foodCategoryEdge",
      cardinality: "many",
    },
  ],
  destinationEdges: [
    {
      sourceField: ["id"],
      destField: ["destinationId"],
      destSchema: "foodCategoryEdge",
      cardinality: "many",
    },
  ],
  ancestorClosures: [
    {
      sourceField: ["id"],
      destField: ["ancestorId"],
      destSchema: "foodCategoryClosure",
      cardinality: "many",
    },
  ],
  descendantClosures: [
    {
      sourceField: ["id"],
      destField: ["descendantId"],
      destSchema: "foodCategoryClosure",
      cardinality: "many",
    },
  ],
} as const;
const foodCollectionRelationships = {
  foodMetas: [
    {
      sourceField: ["id"],
      destField: ["collectionId"],
      destSchema: "foodMeta",
      cardinality: "many",
    },
  ],
  scope: [
    {
      sourceField: ["scopeId"],
      destField: ["id"],
      destSchema: "scope",
      cardinality: "one",
    },
  ],
} as const;
const foodLogEntryRelationships = {
  sourceGroup: [
    {
      sourceField: ["sourceGroupId"],
      destField: ["id"],
      destSchema: "foodLogSourceGroup",
      cardinality: "one",
    },
  ],
  serving: [
    {
      sourceField: ["foodServingId"],
      destField: ["id"],
      destSchema: "foodServing",
      cardinality: "one",
    },
  ],
} as const;
const foodLogSourceGroupRelationships = {
  entries: [
    {
      sourceField: ["id"],
      destField: ["sourceGroupId"],
      destSchema: "foodLogEntry",
      cardinality: "many",
    },
  ],
} as const;
const foodMetaRelationships = {
  collection: [
    {
      sourceField: ["collectionId"],
      destField: ["id"],
      destSchema: "foodCollection",
      cardinality: "one",
    },
  ],
  current: [
    {
      sourceField: ["id", "currentVersion"],
      destField: ["id", "version"],
      destSchema: "food",
      cardinality: "one",
    },
  ],
} as const;
const foodRelationships = {
  servings: [
    {
      sourceField: ["id", "version"],
      destField: ["foodId", "foodVersion"],
      destSchema: "foodServing",
      cardinality: "many",
    },
  ],
  categoryAssociations: [
    {
      sourceField: ["id", "version"],
      destField: ["foodId", "foodVersion"],
      destSchema: "foodCategoryAssociation",
      cardinality: "many",
    },
  ],
  meta: [
    {
      sourceField: ["id"],
      destField: ["id"],
      destSchema: "foodMeta",
      cardinality: "one",
    },
  ],
  metaIfCurrent: [
    {
      sourceField: ["id", "version"],
      destField: ["id", "currentVersion"],
      destSchema: "foodMeta",
      cardinality: "one",
    },
  ],
} as const;
const foodServingRelationships = {
  food: [
    {
      sourceField: ["foodId", "foodVersion"],
      destField: ["id", "version"],
      destSchema: "food",
      cardinality: "one",
    },
  ],
  foodMeta: [
    {
      sourceField: ["foodId"],
      destField: ["id"],
      destSchema: "foodMeta",
      cardinality: "one",
    },
  ],
  massUnit: [
    {
      sourceField: ["massUnitKey"],
      destField: ["key"],
      destSchema: "unit",
      cardinality: "one",
    },
  ],
  volumeUnit: [
    {
      sourceField: ["volumeUnitKey"],
      destField: ["key"],
      destSchema: "unit",
      cardinality: "one",
    },
  ],
} as const;
const genericFoodRelationships = {
  base: [
    {
      sourceField: ["id", "version"],
      destField: ["id", "version"],
      destSchema: "food",
      cardinality: "one",
    },
  ],
  meta: [
    {
      sourceField: ["id"],
      destField: ["id"],
      destSchema: "foodMeta",
      cardinality: "one",
    },
  ],
  metaIfCurrent: [
    {
      sourceField: ["id", "version"],
      destField: ["id", "currentVersion"],
      destSchema: "foodMeta",
      cardinality: "one",
    },
  ],
} as const;
const groupInviteRelationships = {
  group: [
    {
      sourceField: ["groupId"],
      destField: ["id"],
      destSchema: "group",
      cardinality: "one",
    },
  ],
} as const;
const groupMemberRelationships = {
  group: [
    {
      sourceField: ["groupId"],
      destField: ["id"],
      destSchema: "group",
      cardinality: "one",
    },
  ],
} as const;
const groupRelationships = {
  members: [
    {
      sourceField: ["id"],
      destField: ["groupId"],
      destSchema: "groupMember",
      cardinality: "many",
    },
  ],
  invites: [
    {
      sourceField: ["id"],
      destField: ["groupId"],
      destSchema: "groupInvite",
      cardinality: "many",
    },
  ],
  space: [
    {
      sourceField: ["id"],
      destField: ["id"],
      destSchema: "space",
      cardinality: "one",
    },
  ],
} as const;
const listCollectionRelationships = {
  lists: [
    {
      sourceField: ["id"],
      destField: ["collectionId"],
      destSchema: "list",
      cardinality: "many",
    },
  ],
} as const;
const listItemRelationships = {
  list: [
    {
      sourceField: ["listId"],
      destField: ["id"],
      destSchema: "list",
      cardinality: "one",
    },
  ],
  section: [
    {
      sourceField: ["sectionId"],
      destField: ["id"],
      destSchema: "listSection",
      cardinality: "one",
    },
  ],
  shoppingListFoodItem: [
    {
      sourceField: ["id"],
      destField: ["id"],
      destSchema: "shoppingListFoodItem",
      cardinality: "one",
    },
  ],
} as const;
const listRelationships = {
  collection: [
    {
      sourceField: ["collectionId"],
      destField: ["id"],
      destSchema: "listCollection",
      cardinality: "one",
    },
  ],
  sections: [
    {
      sourceField: ["id"],
      destField: ["listId"],
      destSchema: "listSection",
      cardinality: "many",
    },
  ],
  items: [
    {
      sourceField: ["id"],
      destField: ["listId"],
      destSchema: "listItem",
      cardinality: "many",
    },
  ],
} as const;
const listSectionRelationships = {
  list: [
    {
      sourceField: ["listId"],
      destField: ["id"],
      destSchema: "list",
      cardinality: "one",
    },
  ],
  items: [
    {
      sourceField: ["id"],
      destField: ["sectionId"],
      destSchema: "listItem",
      cardinality: "many",
    },
  ],
} as const;
const mealPlanAgentSessionRelationships = {
  mealPlan: [
    {
      sourceField: ["mealPlanId"],
      destField: ["id"],
      destSchema: "mealPlan",
      cardinality: "one",
    },
  ],
  base: [
    {
      sourceField: ["id"],
      destField: ["id"],
      destSchema: "agentSession",
      cardinality: "one",
    },
  ],
  mealWorkflowExecutions: [
    {
      sourceField: ["id"],
      destField: ["agentSessionId"],
      destSchema: "mealPlanMealWorkflowExecution",
      cardinality: "many",
    },
  ],
} as const;
const mealPlanInviteRelationships = {
  mealPlan: [
    {
      sourceField: ["mealPlanId"],
      destField: ["id"],
      destSchema: "mealPlan",
      cardinality: "one",
    },
  ],
} as const;
const mealPlanMealWorkflowExecutionRelationships = {
  mealPlan: [
    {
      sourceField: ["mealPlanId"],
      destField: ["id"],
      destSchema: "mealPlan",
      cardinality: "one",
    },
  ],
  meal: [
    {
      sourceField: ["mealId"],
      destField: ["id"],
      destSchema: "plannedMeal",
      cardinality: "one",
    },
  ],
  workflowExecution: [
    {
      sourceField: ["workflowExecutionId"],
      destField: ["id"],
      destSchema: "workflowExecution",
      cardinality: "one",
    },
  ],
  session: [
    {
      sourceField: ["agentSessionId"],
      destField: ["id"],
      destSchema: "mealPlanAgentSession",
      cardinality: "one",
    },
  ],
} as const;
const mealPlanMemberRelationships = {
  mealPlan: [
    {
      sourceField: ["mealPlanId"],
      destField: ["id"],
      destSchema: "mealPlan",
      cardinality: "one",
    },
  ],
} as const;
const mealPlanRelationships = {
  meals: [
    {
      sourceField: ["id"],
      destField: ["mealPlanId"],
      destSchema: "plannedMeal",
      cardinality: "many",
    },
  ],
  slots: [
    {
      sourceField: ["id"],
      destField: ["mealPlanId"],
      destSchema: "plannedMealSlot",
      cardinality: "many",
    },
  ],
  members: [
    {
      sourceField: ["id"],
      destField: ["mealPlanId"],
      destSchema: "mealPlanMember",
      cardinality: "many",
    },
  ],
  invites: [
    {
      sourceField: ["id"],
      destField: ["mealPlanId"],
      destSchema: "mealPlanInvite",
      cardinality: "many",
    },
  ],
} as const;
const mealPlanningMemberContextAgentSessionRelationships = {
  base: [
    {
      sourceField: ["id"],
      destField: ["id"],
      destSchema: "agentSession",
      cardinality: "one",
    },
  ],
  mealPlanningSession: [
    {
      sourceField: ["mealPlanningSessionId"],
      destField: ["id"],
      destSchema: "mealPlanningSession",
      cardinality: "one",
    },
  ],
} as const;
const mealPlanningSessionMemberContextRelationships = {
  mealPlanningSession: [
    {
      sourceField: ["mealPlanningSessionId"],
      destField: ["id"],
      destSchema: "mealPlanningSession",
      cardinality: "one",
    },
  ],
} as const;
const mealPlanningSessionPlannedMealRelationships = {
  mealPlanningSession: [
    {
      sourceField: ["scopeId", "mealPlanningSessionId"],
      destField: ["scopeId", "id"],
      destSchema: "mealPlanningSession",
      cardinality: "one",
    },
  ],
  plannedMeal: [
    {
      sourceField: ["scopeId", "plannedMealId"],
      destField: ["scopeId", "id"],
      destSchema: "plannedMealV2",
      cardinality: "one",
    },
  ],
} as const;
const mealPlanningSessionPlannerAgentSessionRelationships = {
  base: [
    {
      sourceField: ["id"],
      destField: ["id"],
      destSchema: "agentSession",
      cardinality: "one",
    },
  ],
  mealPlanningSession: [
    {
      sourceField: ["mealPlanningSessionId"],
      destField: ["id"],
      destSchema: "mealPlanningSession",
      cardinality: "one",
    },
  ],
  workflowExecutions: [
    {
      sourceField: ["id"],
      destField: ["agentSessionId"],
      destSchema: "mealPlanningWorkflowExecution",
      cardinality: "many",
    },
  ],
} as const;
const mealPlanningSessionRelationships = {
  group: [
    {
      sourceField: ["id"],
      destField: ["id"],
      destSchema: "group",
      cardinality: "one",
    },
  ],
  scope: [
    {
      sourceField: ["scopeId"],
      destField: ["id"],
      destSchema: "scope",
      cardinality: "one",
    },
  ],
  plannedMealLinks: [
    {
      sourceField: ["scopeId", "id"],
      destField: ["scopeId", "mealPlanningSessionId"],
      destSchema: "mealPlanningSessionPlannedMeal",
      cardinality: "many",
    },
  ],
  scheduleConfig: [
    {
      sourceField: ["id"],
      destField: ["mealPlanningSessionId"],
      destSchema: "mealPlanningSessionScheduleConfig",
      cardinality: "one",
    },
  ],
  memberContexts: [
    {
      sourceField: ["id"],
      destField: ["mealPlanningSessionId"],
      destSchema: "mealPlanningSessionMemberContext",
      cardinality: "many",
    },
  ],
} as const;
const mealPlanningSessionScheduleConfigRelationships = {
  mealPlanningSession: [
    {
      sourceField: ["mealPlanningSessionId"],
      destField: ["id"],
      destSchema: "mealPlanningSession",
      cardinality: "one",
    },
  ],
} as const;
const mealPlanningWorkflowExecutionRelationships = {
  base: [
    {
      sourceField: ["id"],
      destField: ["id"],
      destSchema: "workflowExecution",
      cardinality: "one",
    },
  ],
  mealPlanningSession: [
    {
      sourceField: ["mealPlanningSessionId"],
      destField: ["id"],
      destSchema: "mealPlanningSession",
      cardinality: "one",
    },
  ],
  plannedMeal: [
    {
      sourceField: ["plannedMealId"],
      destField: ["id"],
      destSchema: "plannedMealV2",
      cardinality: "one",
    },
  ],
  agentSession: [
    {
      sourceField: ["agentSessionId"],
      destField: ["id"],
      destSchema: "mealPlanningSessionPlannerAgentSession",
      cardinality: "one",
    },
  ],
} as const;
const mealScheduleRelationships = {
  scope: [
    {
      sourceField: ["scopeId"],
      destField: ["id"],
      destSchema: "scope",
      cardinality: "one",
    },
  ],
  slots: [
    {
      sourceField: ["id"],
      destField: ["mealScheduleId"],
      destSchema: "mealScheduleSlot",
      cardinality: "many",
    },
  ],
} as const;
const mealScheduleSlotRelationships = {
  schedule: [
    {
      sourceField: ["mealScheduleId"],
      destField: ["id"],
      destSchema: "mealSchedule",
      cardinality: "one",
    },
  ],
} as const;
const nutrientRelationships = {
  unit: [
    {
      sourceField: ["unitKey"],
      destField: ["key"],
      destSchema: "unit",
      cardinality: "one",
    },
  ],
} as const;
const nutritionProgramDayRelationships = {
  program: [
    {
      sourceField: ["programId"],
      destField: ["id"],
      destSchema: "nutritionProgram",
      cardinality: "one",
    },
  ],
} as const;
const nutritionProgramExpenditureRelationships = {
  program: [
    {
      sourceField: ["programId"],
      destField: ["id"],
      destSchema: "nutritionProgram",
      cardinality: "one",
    },
  ],
  goal: [
    {
      sourceField: ["goalId"],
      destField: ["id"],
      destSchema: "bodyMetricGoal",
      cardinality: "one",
    },
  ],
} as const;
const nutritionProgramRelationships = {
  expenditure: [
    {
      sourceField: ["id"],
      destField: ["programId"],
      destSchema: "nutritionProgramExpenditure",
      cardinality: "one",
    },
  ],
  days: [
    {
      sourceField: ["id"],
      destField: ["programId"],
      destSchema: "nutritionProgramDay",
      cardinality: "many",
    },
  ],
} as const;
const plannedMealEventAssignmentV2Relationships = {
  event: [
    {
      sourceField: ["mealId", "eventId"],
      destField: ["mealId", "id"],
      destSchema: "plannedMealEventV2",
      cardinality: "one",
    },
  ],
  plate: [
    {
      sourceField: ["mealId", "plateId", "userId"],
      destField: ["mealId", "id", "userId"],
      destSchema: "plannedMealPlateV2",
      cardinality: "one",
    },
  ],
  foodLogSourceGroup: [
    {
      sourceField: ["id"],
      destField: ["sourceId"],
      destSchema: "foodLogSourceGroup",
      cardinality: "one",
    },
  ],
} as const;
const plannedMealEventV2Relationships = {
  plannedMeal: [
    {
      sourceField: ["mealId"],
      destField: ["id"],
      destSchema: "plannedMealV2",
      cardinality: "one",
    },
  ],
  assignments: [
    {
      sourceField: ["mealId", "id"],
      destField: ["mealId", "eventId"],
      destSchema: "plannedMealEventAssignmentV2",
      cardinality: "many",
    },
  ],
} as const;
const plannedMealItemDescriptorRelationships = {
  meal: [
    {
      sourceField: ["mealId"],
      destField: ["id"],
      destSchema: "plannedMeal",
      cardinality: "one",
    },
  ],
} as const;
const plannedMealItemRelationships = {
  meal: [
    {
      sourceField: ["mealId"],
      destField: ["id"],
      destSchema: "plannedMeal",
      cardinality: "one",
    },
  ],
  serving: [
    {
      sourceField: ["foodServingId"],
      destField: ["id"],
      destSchema: "foodServing",
      cardinality: "one",
    },
  ],
} as const;
const plannedMealNutrientTargetsRelationships = {
  mealPlan: [
    {
      sourceField: ["mealPlanId"],
      destField: ["id"],
      destSchema: "mealPlan",
      cardinality: "one",
    },
  ],
  slot: [
    {
      sourceField: ["mealSlotId"],
      destField: ["id"],
      destSchema: "plannedMealSlot",
      cardinality: "one",
    },
  ],
} as const;
const plannedMealOccurrenceRelationships = {
  meal: [
    {
      sourceField: ["mealId"],
      destField: ["id"],
      destSchema: "plannedMeal",
      cardinality: "one",
    },
  ],
  foodLogSourceGroup: [
    {
      sourceField: ["id"],
      destField: ["sourceId"],
      destSchema: "foodLogSourceGroup",
      cardinality: "one",
    },
  ],
} as const;
const plannedMealPlateItemDescriptorV2Relationships = {
  plate: [
    {
      sourceField: ["mealId", "plateId"],
      destField: ["mealId", "id"],
      destSchema: "plannedMealPlateV2",
      cardinality: "one",
    },
  ],
} as const;
const plannedMealPlateItemV2Relationships = {
  plate: [
    {
      sourceField: ["mealId", "plateId"],
      destField: ["mealId", "id"],
      destSchema: "plannedMealPlateV2",
      cardinality: "one",
    },
  ],
  serving: [
    {
      sourceField: ["foodServingId"],
      destField: ["id"],
      destSchema: "foodServing",
      cardinality: "one",
    },
  ],
} as const;
const plannedMealPlateV2Relationships = {
  plannedMeal: [
    {
      sourceField: ["mealId"],
      destField: ["id"],
      destSchema: "plannedMealV2",
      cardinality: "one",
    },
  ],
  items: [
    {
      sourceField: ["mealId", "id"],
      destField: ["mealId", "plateId"],
      destSchema: "plannedMealPlateItemV2",
      cardinality: "many",
    },
  ],
  itemDescriptors: [
    {
      sourceField: ["mealId", "id"],
      destField: ["mealId", "plateId"],
      destSchema: "plannedMealPlateItemDescriptorV2",
      cardinality: "many",
    },
  ],
  assignments: [
    {
      sourceField: ["mealId", "id", "userId"],
      destField: ["mealId", "plateId", "userId"],
      destSchema: "plannedMealEventAssignmentV2",
      cardinality: "many",
    },
  ],
} as const;
const plannedMealRelationships = {
  mealPlan: [
    {
      sourceField: ["mealPlanId"],
      destField: ["id"],
      destSchema: "mealPlan",
      cardinality: "one",
    },
  ],
  slot: [
    {
      sourceField: ["mealSlotId"],
      destField: ["id"],
      destSchema: "plannedMealSlot",
      cardinality: "one",
    },
  ],
  items: [
    {
      sourceField: ["id"],
      destField: ["mealId"],
      destSchema: "plannedMealItem",
      cardinality: "many",
    },
  ],
  itemDescriptors: [
    {
      sourceField: ["id"],
      destField: ["mealId"],
      destSchema: "plannedMealItemDescriptor",
      cardinality: "many",
    },
  ],
  occurrences: [
    {
      sourceField: ["id"],
      destField: ["mealId"],
      destSchema: "plannedMealOccurrence",
      cardinality: "many",
    },
  ],
} as const;
const plannedMealSlotRelationships = {
  mealPlan: [
    {
      sourceField: ["mealPlanId"],
      destField: ["id"],
      destSchema: "mealPlan",
      cardinality: "one",
    },
  ],
  meals: [
    {
      sourceField: ["id"],
      destField: ["mealSlotId"],
      destSchema: "plannedMeal",
      cardinality: "many",
    },
  ],
  userNutrientTargets: [
    {
      sourceField: ["id"],
      destField: ["mealSlotId"],
      destSchema: "plannedMealNutrientTargets",
      cardinality: "many",
    },
  ],
} as const;
const plannedMealV2Relationships = {
  scope: [
    {
      sourceField: ["scopeId"],
      destField: ["id"],
      destSchema: "scope",
      cardinality: "one",
    },
  ],
  plates: [
    {
      sourceField: ["id"],
      destField: ["mealId"],
      destSchema: "plannedMealPlateV2",
      cardinality: "many",
    },
  ],
  events: [
    {
      sourceField: ["id"],
      destField: ["mealId"],
      destSchema: "plannedMealEventV2",
      cardinality: "many",
    },
  ],
} as const;
const recipeIngredientRelationships = {
  recipe: [
    {
      sourceField: ["recipeId", "recipeVersion"],
      destField: ["id", "version"],
      destSchema: "recipe",
      cardinality: "one",
    },
  ],
  serving: [
    {
      sourceField: ["foodServingId"],
      destField: ["id"],
      destSchema: "foodServing",
      cardinality: "one",
    },
  ],
} as const;
const recipeRelationships = {
  base: [
    {
      sourceField: ["id", "version"],
      destField: ["id", "version"],
      destSchema: "food",
      cardinality: "one",
    },
  ],
  meta: [
    {
      sourceField: ["id"],
      destField: ["id"],
      destSchema: "foodMeta",
      cardinality: "one",
    },
  ],
  metaIfCurrent: [
    {
      sourceField: ["id", "version"],
      destField: ["id", "currentVersion"],
      destSchema: "foodMeta",
      cardinality: "one",
    },
  ],
  ingredients: [
    {
      sourceField: ["id", "version"],
      destField: ["recipeId", "recipeVersion"],
      destSchema: "recipeIngredient",
      cardinality: "many",
    },
  ],
  steps: [
    {
      sourceField: ["id", "version"],
      destField: ["recipeId", "recipeVersion"],
      destSchema: "recipeStep",
      cardinality: "many",
    },
  ],
  serving: [
    {
      sourceField: ["id", "version"],
      destField: ["recipeId", "recipeVersion"],
      destSchema: "recipeServing",
      cardinality: "one",
    },
  ],
  variations: [
    {
      sourceField: ["id", "version"],
      destField: ["recipeId", "recipeVersion"],
      destSchema: "recipeVariation",
      cardinality: "many",
    },
  ],
} as const;
const recipeServingRelationships = {
  recipe: [
    {
      sourceField: ["recipeId", "recipeVersion"],
      destField: ["id", "version"],
      destSchema: "recipe",
      cardinality: "one",
    },
  ],
  base: [
    {
      sourceField: ["id"],
      destField: ["id"],
      destSchema: "foodServing",
      cardinality: "one",
    },
  ],
} as const;
const recipeStepRelationships = {
  recipe: [
    {
      sourceField: ["recipeId", "recipeVersion"],
      destField: ["id", "version"],
      destSchema: "recipe",
      cardinality: "one",
    },
  ],
} as const;
const recipeVariationIngredientPatchRelationships = {
  variant: [
    {
      sourceField: ["recipeVariationId", "recipeVariationVersion"],
      destField: ["id", "version"],
      destSchema: "recipeVariation",
      cardinality: "one",
    },
  ],
  baseServing: [
    {
      sourceField: ["baseFoodServingId"],
      destField: ["id"],
      destSchema: "foodServing",
      cardinality: "one",
    },
  ],
  newServing: [
    {
      sourceField: ["newFoodServingId"],
      destField: ["id"],
      destSchema: "foodServing",
      cardinality: "one",
    },
  ],
} as const;
const recipeVariationRelationships = {
  base: [
    {
      sourceField: ["id", "version"],
      destField: ["id", "version"],
      destSchema: "food",
      cardinality: "one",
    },
  ],
  meta: [
    {
      sourceField: ["id"],
      destField: ["id"],
      destSchema: "foodMeta",
      cardinality: "one",
    },
  ],
  metaIfCurrent: [
    {
      sourceField: ["id", "version"],
      destField: ["id", "currentVersion"],
      destSchema: "foodMeta",
      cardinality: "one",
    },
  ],
  recipe: [
    {
      sourceField: ["recipeId", "recipeVersion"],
      destField: ["id", "version"],
      destSchema: "recipe",
      cardinality: "one",
    },
  ],
  ingredientPatches: [
    {
      sourceField: ["id", "version"],
      destField: ["recipeVariationId", "recipeVariationVersion"],
      destSchema: "recipeVariationIngredientPatch",
      cardinality: "many",
    },
  ],
  stepPatches: [
    {
      sourceField: ["id", "version"],
      destField: ["recipeVariationId", "recipeVariationVersion"],
      destSchema: "recipeVariationStepPatch",
      cardinality: "many",
    },
  ],
} as const;
const recipeVariationStepPatchRelationships = {
  variant: [
    {
      sourceField: ["recipeVariationId", "recipeVariationVersion"],
      destField: ["id", "version"],
      destSchema: "recipeVariation",
      cardinality: "one",
    },
  ],
} as const;
const scopeRelationships = {
  space: [
    {
      sourceField: ["spaceId"],
      destField: ["id"],
      destSchema: "space",
      cardinality: "one",
    },
  ],
  userProfile: [
    {
      sourceField: ["userId"],
      destField: ["userId"],
      destSchema: "userProfile",
      cardinality: "one",
    },
  ],
  mealPlanningSession: [
    {
      sourceField: ["mealPlanningSessionId"],
      destField: ["id"],
      destSchema: "mealPlanningSession",
      cardinality: "one",
    },
  ],
} as const;
const shoppingListFoodItemRelationships = {
  shoppingList: [
    {
      sourceField: ["shoppingListId"],
      destField: ["id"],
      destSchema: "shoppingList",
      cardinality: "one",
    },
  ],
  base: [
    {
      sourceField: ["id"],
      destField: ["id"],
      destSchema: "listItem",
      cardinality: "one",
    },
  ],
  serving: [
    {
      sourceField: ["foodServingId"],
      destField: ["id"],
      destSchema: "foodServing",
      cardinality: "one",
    },
  ],
} as const;
const shoppingListRelationships = {
  base: [
    {
      sourceField: ["id"],
      destField: ["id"],
      destSchema: "list",
      cardinality: "one",
    },
  ],
  items: [
    {
      sourceField: ["id"],
      destField: ["shoppingListId"],
      destSchema: "shoppingListFoodItem",
      cardinality: "many",
    },
  ],
} as const;
const spaceRelationships = {
  group: [
    {
      sourceField: ["id"],
      destField: ["id"],
      destSchema: "group",
      cardinality: "one",
    },
  ],
  scope: [
    {
      sourceField: ["id"],
      destField: ["id"],
      destSchema: "scope",
      cardinality: "one",
    },
  ],
} as const;
const workflowExecutionRelationships = {
  steps: [
    {
      sourceField: ["id"],
      destField: ["executionId"],
      destSchema: "workflowExecutionStep",
      cardinality: "many",
    },
  ],
  mealWorkflowExecutions: [
    {
      sourceField: ["id"],
      destField: ["workflowExecutionId"],
      destSchema: "mealPlanMealWorkflowExecution",
      cardinality: "many",
    },
  ],
  mealPlanningWorkflowExecutions: [
    {
      sourceField: ["id"],
      destField: ["id"],
      destSchema: "mealPlanningWorkflowExecution",
      cardinality: "many",
    },
  ],
} as const;
const workflowExecutionStepRelationships = {
  execution: [
    {
      sourceField: ["executionId"],
      destField: ["id"],
      destSchema: "workflowExecution",
      cardinality: "one",
    },
  ],
  parentStep: [
    {
      sourceField: ["parentStepId"],
      destField: ["id"],
      destSchema: "workflowExecutionStep",
      cardinality: "one",
    },
  ],
  childSteps: [
    {
      sourceField: ["id"],
      destField: ["parentStepId"],
      destSchema: "workflowExecutionStep",
      cardinality: "many",
    },
  ],
} as const;
/**
 * The Zero schema object.
 * This type is auto-generated from your Drizzle schema definition.
 */
export const schema = {
  tables: {
    accessGrant: accessGrantTable,
    agentSession: agentSessionTable,
    agentSessionMessage: agentSessionMessageTable,
    bodyCharacteristic: bodyCharacteristicTable,
    bodyMetric: bodyMetricTable,
    bodyMetricEntry: bodyMetricEntryTable,
    bodyMetricGoal: bodyMetricGoalTable,
    bodyMetricSample: bodyMetricSampleTable,
    bodyMetricTarget: bodyMetricTargetTable,
    brandedFood: brandedFoodTable,
    brandedFoodServingNutrient: brandedFoodServingNutrientTable,
    draft: draftTable,
    externalFoodCollection: externalFoodCollectionTable,
    externalFoodIdentity: externalFoodIdentityTable,
    externalFoodProvenance: externalFoodProvenanceTable,
    externalNutrientRef: externalNutrientRefTable,
    food: foodTable,
    foodCategory: foodCategoryTable,
    foodCategoryAssociation: foodCategoryAssociationTable,
    foodCategoryClosure: foodCategoryClosureTable,
    foodCategoryEdge: foodCategoryEdgeTable,
    foodCollection: foodCollectionTable,
    foodLogEntry: foodLogEntryTable,
    foodLogSourceGroup: foodLogSourceGroupTable,
    foodMeta: foodMetaTable,
    foodServing: foodServingTable,
    genericFood: genericFoodTable,
    genericFoodNutrient: genericFoodNutrientTable,
    group: groupTable,
    groupInvite: groupInviteTable,
    groupMember: groupMemberTable,
    language: languageTable,
    list: listTable,
    listCollection: listCollectionTable,
    listItem: listItemTable,
    listSection: listSectionTable,
    locale: localeTable,
    mealPlan: mealPlanTable,
    mealPlanAgentSession: mealPlanAgentSessionTable,
    mealPlanInvite: mealPlanInviteTable,
    mealPlanMealWorkflowExecution: mealPlanMealWorkflowExecutionTable,
    mealPlanMember: mealPlanMemberTable,
    mealPlanningMemberContextAgentSession:
      mealPlanningMemberContextAgentSessionTable,
    mealPlanningSession: mealPlanningSessionTable,
    mealPlanningSessionMemberContext: mealPlanningSessionMemberContextTable,
    mealPlanningSessionPlannedMeal: mealPlanningSessionPlannedMealTable,
    mealPlanningSessionPlannerAgentSession:
      mealPlanningSessionPlannerAgentSessionTable,
    mealPlanningSessionScheduleConfig: mealPlanningSessionScheduleConfigTable,
    mealPlanningWorkflowExecution: mealPlanningWorkflowExecutionTable,
    mealSchedule: mealScheduleTable,
    mealScheduleSlot: mealScheduleSlotTable,
    nutrient: nutrientTable,
    nutritionProgram: nutritionProgramTable,
    nutritionProgramDay: nutritionProgramDayTable,
    nutritionProgramExpenditure: nutritionProgramExpenditureTable,
    plannedMeal: plannedMealTable,
    plannedMealEventAssignmentV2: plannedMealEventAssignmentV2Table,
    plannedMealEventV2: plannedMealEventV2Table,
    plannedMealItem: plannedMealItemTable,
    plannedMealItemDescriptor: plannedMealItemDescriptorTable,
    plannedMealNutrientTargets: plannedMealNutrientTargetsTable,
    plannedMealOccurrence: plannedMealOccurrenceTable,
    plannedMealPlateItemDescriptorV2: plannedMealPlateItemDescriptorV2Table,
    plannedMealPlateItemV2: plannedMealPlateItemV2Table,
    plannedMealPlateV2: plannedMealPlateV2Table,
    plannedMealSlot: plannedMealSlotTable,
    plannedMealV2: plannedMealV2Table,
    recipe: recipeTable,
    recipeIngredient: recipeIngredientTable,
    recipeNutrient: recipeNutrientTable,
    recipeServing: recipeServingTable,
    recipeStep: recipeStepTable,
    recipeVariation: recipeVariationTable,
    recipeVariationIngredientPatch: recipeVariationIngredientPatchTable,
    recipeVariationNutrient: recipeVariationNutrientTable,
    recipeVariationStepPatch: recipeVariationStepPatchTable,
    scope: scopeTable,
    shoppingList: shoppingListTable,
    shoppingListFoodItem: shoppingListFoodItemTable,
    space: spaceTable,
    unit: unitTable,
    unitLocalization: unitLocalizationTable,
    userProfile: userProfileTable,
    workflowExecution: workflowExecutionTable,
    workflowExecutionStep: workflowExecutionStepTable,
  },
  relationships: {
    agentSessionMessage: agentSessionMessageRelationships,
    agentSession: agentSessionRelationships,
    bodyMetricEntry: bodyMetricEntryRelationships,
    bodyMetricGoal: bodyMetricGoalRelationships,
    bodyMetricSample: bodyMetricSampleRelationships,
    bodyMetricTarget: bodyMetricTargetRelationships,
    brandedFood: brandedFoodRelationships,
    externalFoodIdentity: externalFoodIdentityRelationships,
    externalFoodProvenance: externalFoodProvenanceRelationships,
    foodCategoryAssociation: foodCategoryAssociationRelationships,
    foodCategoryClosure: foodCategoryClosureRelationships,
    foodCategoryEdge: foodCategoryEdgeRelationships,
    foodCategory: foodCategoryRelationships,
    foodCollection: foodCollectionRelationships,
    foodLogEntry: foodLogEntryRelationships,
    foodLogSourceGroup: foodLogSourceGroupRelationships,
    foodMeta: foodMetaRelationships,
    food: foodRelationships,
    foodServing: foodServingRelationships,
    genericFood: genericFoodRelationships,
    groupInvite: groupInviteRelationships,
    groupMember: groupMemberRelationships,
    group: groupRelationships,
    listCollection: listCollectionRelationships,
    listItem: listItemRelationships,
    list: listRelationships,
    listSection: listSectionRelationships,
    mealPlanAgentSession: mealPlanAgentSessionRelationships,
    mealPlanInvite: mealPlanInviteRelationships,
    mealPlanMealWorkflowExecution: mealPlanMealWorkflowExecutionRelationships,
    mealPlanMember: mealPlanMemberRelationships,
    mealPlan: mealPlanRelationships,
    mealPlanningMemberContextAgentSession:
      mealPlanningMemberContextAgentSessionRelationships,
    mealPlanningSessionMemberContext:
      mealPlanningSessionMemberContextRelationships,
    mealPlanningSessionPlannedMeal: mealPlanningSessionPlannedMealRelationships,
    mealPlanningSessionPlannerAgentSession:
      mealPlanningSessionPlannerAgentSessionRelationships,
    mealPlanningSession: mealPlanningSessionRelationships,
    mealPlanningSessionScheduleConfig:
      mealPlanningSessionScheduleConfigRelationships,
    mealPlanningWorkflowExecution: mealPlanningWorkflowExecutionRelationships,
    mealSchedule: mealScheduleRelationships,
    mealScheduleSlot: mealScheduleSlotRelationships,
    nutrient: nutrientRelationships,
    nutritionProgramDay: nutritionProgramDayRelationships,
    nutritionProgramExpenditure: nutritionProgramExpenditureRelationships,
    nutritionProgram: nutritionProgramRelationships,
    plannedMealEventAssignmentV2: plannedMealEventAssignmentV2Relationships,
    plannedMealEventV2: plannedMealEventV2Relationships,
    plannedMealItemDescriptor: plannedMealItemDescriptorRelationships,
    plannedMealItem: plannedMealItemRelationships,
    plannedMealNutrientTargets: plannedMealNutrientTargetsRelationships,
    plannedMealOccurrence: plannedMealOccurrenceRelationships,
    plannedMealPlateItemDescriptorV2:
      plannedMealPlateItemDescriptorV2Relationships,
    plannedMealPlateItemV2: plannedMealPlateItemV2Relationships,
    plannedMealPlateV2: plannedMealPlateV2Relationships,
    plannedMeal: plannedMealRelationships,
    plannedMealSlot: plannedMealSlotRelationships,
    plannedMealV2: plannedMealV2Relationships,
    recipeIngredient: recipeIngredientRelationships,
    recipe: recipeRelationships,
    recipeServing: recipeServingRelationships,
    recipeStep: recipeStepRelationships,
    recipeVariationIngredientPatch: recipeVariationIngredientPatchRelationships,
    recipeVariation: recipeVariationRelationships,
    recipeVariationStepPatch: recipeVariationStepPatchRelationships,
    scope: scopeRelationships,
    shoppingListFoodItem: shoppingListFoodItemRelationships,
    shoppingList: shoppingListRelationships,
    space: spaceRelationships,
    workflowExecution: workflowExecutionRelationships,
    workflowExecutionStep: workflowExecutionStepRelationships,
  },
  enableLegacyQueries: false,
  enableLegacyMutators: false,
} as const;

/**
 * Represents the Zero schema type.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Schema = typeof schema;
